(() => {
  'use strict';
  const giftIds = [49081121374393, 49081121407161];
  const fileteiras = [8282411892921, 8282457211065, 8388680777913, 8474819297465];
  function plan(cart, config) {
    if (!Array.isArray(cart?.items)) throw new Error('promo-cart');
    const quantity = ids => cart.items.filter(i => ids.includes(Number(i.product_id)))
      .reduce((sum, i) => sum + i.quantity, 0);
    return [
      { id: giftIds[0], eligible: !!config.fileteiras && quantity(fileteiras) >= 2 },
      { id: giftIds[1], eligible: !!config.sniper && quantity([8254538383545]) >= 1 }
    ];
  }
  async function reconcile(cart, config, request) {
    const root = config.root || '/';
    let added = false;
    for (let attempt = 0; attempt < 12; attempt++) {
      let change;
      const missing = [];
      for (const rule of plan(cart, config)) {
        const lines = cart.items.filter(i => Number(i.variant_id) === rule.id);
        if (!rule.eligible && lines.length) change ||= { id: lines[0].key, quantity: 0 };
        if (rule.eligible) {
          if (!lines.length) missing.push({ id: rule.id, quantity: 1, properties: { _doma_brinde: 'automatico' } });
          else if (lines.length > 1) change ||= { id: lines[1].key, quantity: 0 };
          else if (lines[0].quantity !== 1) change ||= { id: lines[0].key, quantity: 1 };
        }
      }
      if (change) {
        cart = await request(root + 'cart/change.js', change);
        continue;
      }
      if (missing.length) {
        await request(root + 'cart/add.js', { items: missing });
        cart = await request(root + 'cart.js');
        added = true;
        continue;
      }
      const chargedGift = cart.items.find(i => giftIds.includes(Number(i.variant_id)) && i.final_line_price !== 0);
      if (chargedGift) {
        await request(root + 'cart/change.js', { id: chargedGift.key, quantity: 0 });
        throw new Error('promo-not-discounted');
      }
      return { cart, added };
    }
    throw new Error('promo-cart-unstable');
  }
  const api = { plan, reconcile };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (typeof window === 'undefined') return;
  const node = document.getElementById('DomaNativeGiftConfig');
  if (!node) return;
  const config = JSON.parse(node.textContent);
  config.root = config.root.replace(/\/?$/, '/');
  const status = document.getElementById('DomaNativeGiftStatus');
  const request = async (url, body) => {
    const target = new URL(url, location.origin);
    if (target.origin !== location.origin) throw new Error('promo-origin');
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 15000);
    try {
      const response = await fetch(target, {
        method: body ? 'POST' : 'GET', credentials: 'same-origin', mode: 'same-origin',
        cache: 'no-store', signal: controller.signal,
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        ...(body ? { body: JSON.stringify(body) } : {})
      });
      const mime = response.headers.get('content-type')?.split(';')[0].trim();
      if (!response.ok || !['application/json', 'text/javascript', 'application/javascript'].includes(mime)) throw new Error('promo-response');
      return await response.json();
    } finally { clearTimeout(timeout); }
  };
  function celebrate() {
    if (!config.confetti || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const layer = document.createElement('div');
    layer.className = 'doma-gift-confetti';
    layer.setAttribute('aria-hidden', 'true');
    for (let i = 0; i < 18; i++) {
      const piece = document.createElement('i');
      piece.style.left = (5 + Math.random() * 90) + '%';
      piece.style.animationDelay = (Math.random() * 0.3) + 's';
      layer.append(piece);
    }
    document.body.append(layer);
    setTimeout(() => layer.remove(), 1700);
  }
  let busy = false;
  window.DomaNativePromotions = {
    async discount(code) {
      const cart = await request(config.root + 'cart/update.js', { discount: code });
      return this.sync(cart);
    },
    async sync(cart) {
      if (busy) throw new Error('promo-concurrent');
      busy = true;
      try {
        const result = await reconcile(cart || await request(config.root + 'cart.js'), config, request);
        const count = result.cart.items.filter(i => giftIds.includes(Number(i.variant_id))).length;
        if (status) status.textContent = count ? config.confirmed : '';
        if (result.added) celebrate();
        return result.cart;
      } catch (error) {
        if (status) status.textContent = config.error;
        throw error;
      } finally { busy = false; }
    }
  };
  const form = document.getElementById('DomaCartCoupon');
  // Keep the form outside AJAX-replaced totals so listeners, input and feedback survive.
  const couponSlot = document.querySelector('[data-doma-coupon-slot]');
  if (form && couponSlot) couponSlot.append(form);
  form?.addEventListener('submit', async event => {
    event.preventDefault();
    const code = event.submitter?.name === 'remove_coupon' ? '' : form.elements.discount.value.trim().toUpperCase();
    const output = document.getElementById('DomaCouponStatus');
    if (code && !/^[A-Z0-9_-]{1,64}$/.test(code)) { output.textContent = config.couponInvalid; return; }
    const buttons = [...form.querySelectorAll('button[type="submit"]')];
    buttons.forEach(button => { button.disabled = true; });
    try {
      const cart = await document.querySelector('cart-items').applyDiscount(code);
      if (!code) form.elements.discount.value = '';
      const applied = cart.discount_codes?.some(d => d.code.toUpperCase() === code && d.applicable);
      output.textContent = !code ? config.couponRemoved : applied ? config.couponApplied : config.couponInvalid;
    } catch { output.textContent = config.error; }
    finally { buttons.forEach(button => { button.disabled = false; }); }
  });
})();
